import { render, staticRenderFns } from "./National-from.vue?vue&type=template&id=62a84731&scoped=true&"
import script from "./National-from.vue?vue&type=script&lang=js&"
export * from "./National-from.vue?vue&type=script&lang=js&"
import style0 from "./National-from.vue?vue&type=style&index=0&id=62a84731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a84731",
  null
  
)

export default component.exports